import type { GlossaryProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

export const Glossary = (props: GlossaryProps) => {
  return <LazyComponent<GlossaryProps> name="Glossary" {...props} />;
};
